import Vue from 'vue'
import TextFilters from './text'

Vue.use(TextFilters)
